/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import React, { useState, useRef, useEffect } from 'react'
import ApolloClient, { gql } from 'apollo-boost'
import { ApolloProvider, Query, useQuery } from 'react-apollo'
import { useLocation } from 'react-router-dom'
import dayjs from 'dayjs'
import moment from 'moment'

// Ant Design
import { Row, Col, Avatar, DatePicker, Pagination, Empty } from 'antd'
// import { Link } from 'Anchor'

// Images
import girlAvatar from '../../public/img/default_girl_avatar.svg'
import boyAvatar from '../../public/img/default_boy_avatar.svg'


const ProfileImg = ({ avatar, gender }) => {
	if (avatar) return <Avatar src={avatar} alt='avatar' size={80} />
	else if (!avatar && gender === 'FEMALE') return <Avatar src={girlAvatar} alt='avatar' size={80} />
	else return <Avatar src={boyAvatar} alt='avatar' size={80} />
}

const PaginationComponent = ({ total, paginationProps, setPaginationProps }) => {
	const { currentPage, limit } = paginationProps
	return (
		<Pagination
			total={total}
			current={currentPage}
			pageSize={limit}
			showSizeChanger
			showQuickJumper
			showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} applicants`}
			style={{
				float: 'right',
				marginTop: '2em'
			}}
			onChange={page => {
				setPaginationProps({ ...paginationProps, currentPage: page })
				window.sessionStorage.setItem('applicantsListPageProps', JSON.stringify({ currentPage: page, limit }))
			}}
			onShowSizeChange={(current, size) => {
				setPaginationProps({ ...paginationProps, limit: size, currentPage: 1 })
				window.sessionStorage.setItem('applicantsListProps', JSON.stringify({ currentPage: current, limit: size }))
			}}
		/>
	)
}

// This component maps through an arr from JobApplicant (Job Applications) and render them ...
const Applicants = ({ jobId, isECDA }) => {
	const [dateRange, setDateRange] = useState({ startDate: null, endDate: null })
	const { startDate, endDate } = dateRange

	// Get initial state
	// const [paginationProps, setPaginationProps] = useState({
	//   currentPage: 1,
	//   limit: 10
	// })
	const [paginationProps, setPaginationProps] = useState(() => {
		if (window.sessionStorage.getItem('applicantsListPageProps') !== null) return JSON.parse(window.sessionStorage.getItem('applicantsListPageProps')??'')
		else return { currentPage: 1, limit: 10 }
	})
	const { currentPage, limit } = paginationProps

	const { RangePicker } = DatePicker

	// Get all Applications
	const GET_APPLICANTS_INFO = gql`
    query ($jobId: Int!, $startDate: timestamptz, $endDate: timestamptz, $limit: Int!, $offset: Int!) {
      JobApplicant(limit: $limit
        offset: $offset
        where: {
          job: {_eq: $jobId}
          createdAt: {_gte: $startDate _lte: $endDate}
        } order_by: {id: desc}) {
        Applicant {
          dateOfBirth
          age
          avatar
          gender
          id
          name
          nationality
          cv
          isAvailable
          education
          Enum_EducationLevel { display}
          Address { streetAddress}
          # where clause for ADMIN
          ApplicantAccesses {
            applicantId
            userId
            updatedAt
            # Grab row(s) regardless of source(s)
            ApplicantAccessActions(where: {action: {_eq: "VIEWED"}}) {
              count
              source
              updatedAt
            }
            otherSources: ApplicantAccessActions(
              where: {
                action: {_eq: "VIEWED"},
                source: {_neq: JOBAPPLICANT}
              },
              order_by: {updatedAt: desc}
            ) {
              count
              updatedAt
            }
          }
        }
        applicant
        createdAt
        id
        status
      }

      JobApplicant_aggregate(where: {
        job: {_eq: $jobId}
        createdAt: {_gte: $startDate, _lte: $endDate}
      }) {
        aggregate { count}
      }
    }
  `

	// Get job query
	const GET_JOB = gql`
    query ($jobId: Int!) {
      Job_by_pk(id: $jobId) {
        createdAt
      }
    }
  `

	// Job details
	const { data } = useQuery(GET_JOB, {
		variables: { jobId }
	})

	let startBlockDate = ''
	if (typeof data !== 'undefined') {
		startBlockDate = data.Job_by_pk.createdAt
	}

	// let GET_APPLICANTS_INFO
	const variables = {
		jobId,
		startDate: startDate !== null ? new Date(startDate).toISOString() : null,
		endDate: endDate !== null ? new Date(endDate).toISOString() : null,
		limit,
		offset: (currentPage - 1) * limit
		// limit: sessionStorage.getItem('applicantsListPageProps', JSON.stringify()),
		// offset:
	}



	// eslint-disable-next-line
  const scrollToApplicant = localStorage.getItem('scrollToApplicant')
	const myRef = useRef(null)
	useEffect(() => {
		if (myRef.current) {
			window.scrollTo({
				top: myRef.current.offsetTop - 10
			})
			// eslint-disable-next-line
      localStorage.removeItem('scrollToApplicant')
		}
	}, [])

	return (
		<Query
			query={GET_APPLICANTS_INFO}
			variables={variables}
		>
			{({ loading, error, data }) => {
				if (loading) return <div style={{ textAlign: 'center' }}><br />{'Loading'}</div>
				if (error) return <div>{'Error'}</div>

				const { JobApplicant: applicationDatas, JobApplicant_aggregate: { aggregate: { count } } } = data

				return (
					<>
						<Row style={{ justifyContent: 'center' }}>
							<Col md={8} xs={24}>
								<Row>
									<Col md={24} xs={24}>
										<span>{count} {applicationDatas.length > 1 ? 'Jobseekers' : 'Jobseeker'}</span>
									</Col>
								</Row>
							</Col>
							<Col md={8} xs={24} style={{ textAlign: 'right' }}>
								<RangePicker
									disabledDate={(current) => {
										const tooEarly = current.isBefore(moment(startBlockDate))
										const tooLate = current.isAfter(moment())
										return tooEarly || tooLate
									}}
									value={[(startDate !== null && endDate !== null) ? startDate : '', (endDate !== null && startDate !== null) ? endDate : '']}
									format='DD MMM YYYY'
									onCalendarChange={momentDate => {
										if (momentDate !== null) {
											// if (momentDate[0] !== '' && momentDate[1] !== '') {
											if (momentDate[0] && momentDate[1]) {
												setDateRange({ startDate: momentDate[0], endDate: momentDate[1] })
											}
										} else setDateRange({ startDate: null, endDate: null })
									}}
								/>
							</Col>
						</Row>
						{applicationDatas.length <= 0 && (
							<div>
								<br /><br />
								<Empty description={false} />
								<p style={{ textAlign: 'center' }}>No applicants</p>
							</div>
						)}
						<Row style={{ justifyContent: 'center' }}>
							<Col md={16} xs={24}>
								<div>
									{applicationDatas.map(application => {
										// Contains applicants' info
										const applicant = application.Applicant

										// Stores true only when currentUser has viewed profile before
										let userHasViewed = false
										// Change this to check from ApplicantAccessAction
										if (applicant.ApplicantAccesses.length) {
											const obj = applicant.ApplicantAccesses[0]
											// if User have not Viewed Applicant, straight Rejected, etc
											// Have to check individual row, action === 'VIEWED'
											if (obj.ApplicantAccessActions.length) {
												userHasViewed = true
											}
										}
										// userHasViewed = applicant.ApplicantAccesses.some(obj => obj.userId === userId)

										// Functions returns the correct number of count
										// User may not have Viewed Profile from this source

										const getCount = () => {
											if (userHasViewed) {
												const userActions = applicant.ApplicantAccesses[0].ApplicantAccessActions
												const correspondingAction = userActions.filter(action => action.source === 'JOBAPPLICANT')
												if (correspondingAction.length) return correspondingAction[0].count + 1
												else return 1
											} else {
												return null
											}
										}

										// Another function to return recent VIEWED date
										const recentViewDate = () => {
											if (userHasViewed) {
												// arr containing the "Action(s)" from all sources, action(VIEWED, REJECTED)
												const userActions = applicant.ApplicantAccesses[0].ApplicantAccessActions
												const jobApplicantAction = userActions.filter(action => action.source === 'JOBAPPLICANT')
												// If user has not viewed from ApplicantList, grab from otherSources
												const recentViewed = applicant.ApplicantAccesses[0].otherSources[0]
												if (jobApplicantAction.length) return dayjs(jobApplicantAction[0].updatedAt).format('D MMMM YYYY')
												else return dayjs(recentViewed.updatedAt).format('D MMMM YYYY')
											} else {
												return null
											}
										}

										const nationality = () => {
											switch (applicant.nationality) {
											case 'SG':
												return 'Singaporean'
												// break
											case 'SP':
												return 'Singaporean PR'
												// break
											case 'MY':
												return 'Malaysian'
												// break
											default:
												return applicant.nationality
											}
										}

										const getAge = () => {
											const dob = applicant.dateOfBirth
											if (dob !== null) {
												const age = moment().diff(moment(dob, 'YYYYMMDD'), 'years')
												return age
											} else return applicant.age
										}

										const getHighestEdu = () => {
											if (applicant.Enum_EducationLevel !== null) {
												return applicant.Enum_EducationLevel.display
											} else return applicant.education
										}

										const getStreetAddr = () => {
											if (applicant.Address !== null) {
												return applicant.Address.streetAddress
											} else return ''
										}

										return (
										// Each div is each Application
											<div ref={applicant.id === parseInt(scrollToApplicant) ? myRef : null} style={{ backgroundColor: 'white', padding: '2rem', marginBottom: '3px' }} key={application.applicant}>
												<Row justify='space-between' align='middle'>
													<Col xs={24} sm={24} md={12}>
														<Row gutter={[16, { xs: 16, md: 0 }]}>
															<Col>
																<ProfileImg avatar={applicant.avatar} gender={applicant.gender} />
															</Col>
															<Col>
																<h3>
																	{applicant.name} &nbsp;
																	{applicant.isAvailable ? (<><span style={{ display: 'inline-block', width: '10px', height: '10px', borderRadius: '5px', backgroundColor: '#7DD09B' }} /></>) : (<><span style={{ display: 'inline-block', width: '10px', height: '10px', borderRadius: '5px', backgroundColor: 'grey' }} /></>)}
																</h3>
																<small style={{ color: '#8F95A0', display: 'block' }}>
																	{!isECDA ? getAge() : getHighestEdu()} |&nbsp;
																	{!isECDA ? applicant.gender : getStreetAddr()} |&nbsp;
																	{nationality()}
																</small>
																<small style={{ color: '#8F95A0' }}>Applied on {dayjs(application.createdAt).format('D MMMM YYYY')}</small>
															</Col>
														</Row>
													</Col>
												</Row>
											</div>

										)
									})}
									{count > 0 && (
										<PaginationComponent
											total={count}
											paginationProps={paginationProps}
											setPaginationProps={setPaginationProps}
										/>
									)}
								</div>
							</Col>
						</Row>
					</>
				)
			}}
		</Query>
	)
}

const List = () => {
	const { state } = useLocation()
	// state contains Job's data
	const { id, title } = state.job
	// userId is ME
	// const userId = currentUser.id

	const client = new ApolloClient({
		uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
		headers: {
			'X-Hasura-Admin-Secret': process.env.REACT_APP_HASURA_SECRET,
		},
	})

	return (
		<>
			<div style={{ backgroundColor: '#ffffff', paddingBottom: '2rem', paddingTop: '1rem', marginBottom: '1rem' }}>
				<h1 style={{ textAlign: 'center', paddingTop: '2rem' }}>Applicants List</h1>
				<p style={{ textAlign: 'center' }}>{title}</p>
			</div>
			<ApolloProvider client={client}>
				<Applicants
					jobId={id}
					isECDA={state.isECDA !== undefined ? state.isECDA : false}
				/>
			</ApolloProvider>
		</>
	)
}

export default List
